import { render, staticRenderFns } from "./FunctionHistoryTab.vue?vue&type=template&id=203859bd&scoped=true&lang=pug"
import script from "./FunctionHistoryTab.vue?vue&type=script&lang=ts"
export * from "./FunctionHistoryTab.vue?vue&type=script&lang=ts"
import style0 from "./FunctionHistoryTab.vue?vue&type=style&index=0&id=203859bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203859bd",
  null
  
)

export default component.exports